module.exports = __webpack_public_path__ + "static/media/Icon_menu_recommend_products.58917289.svg";